module.exports = __webpack_public_path__ + "static/greycliffcf-extraboldoblique-webfont-df043197a9baa417c29e4ae12b311821.woff";